<template>
  <div v-if="customForm && customForm.length" :class="customFormClasses">
    <custom-field-component v-for="form in customForm"
                            :key="form.name + form.value"
                            :data="form" :customFieldClasses="customFieldClasses"
    ></custom-field-component>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import CustomFieldComponent from './CustomFieldComponent';
import {GET_CUSTOM_FORM_DATA} from '@/store/actionTypes';
import {GET_CUSTOM_FORM_DATA_FOR_ALIAS} from '@/store/getterTypes';
import {BASIC_PASS_FIELD_NAME, CUSTOM_FORM_ALIASES} from '@/const';

export default {
  components: {CustomFieldComponent},
  name: 'CustomFormComponent',
  data() {
    return {
      alias: CUSTOM_FORM_ALIASES.USER,
    };
  },
  props: {
    customFormClasses: Array,
    customFieldClasses: Array,
  },
  methods: {
    ...mapActions({getCustomFormData: GET_CUSTOM_FORM_DATA}),
    validate() {
      if (!this.$children.length) return true;
      const isAllValid = [];
      this.$children.forEach((item) => {
        if ('isValid' in item && typeof item.isValid === 'function') {
          isAllValid.push(item.isValid());
        }
      });
      return isAllValid.every((i) => i);
    },
    getFieldsData() {
      const data = {};
      this.$children.forEach((child) => {
        if ('formData' in child && child.formData.name) {
          data[child.formData.name] = child.value;
        }
      });
      return data;
    },
  },
  computed: {
    customForm() {
      return this.$store.getters[GET_CUSTOM_FORM_DATA_FOR_ALIAS](this.alias)?.filter?.(({name}) => {
        return name !== BASIC_PASS_FIELD_NAME;
      });
    },
  },
  mounted() {
    if (!this.customForm?.length) {
      this.getCustomFormData(this.alias);
    }
  },
};
</script>
